import { useEffect, useRef } from 'react';
import { byJSONviewer } from './json';
import './json.css';
import './json.dark.css';
import './json.light.css';

export const EasyJsonViewer = ({ data }: { data: unknown }) => {
  const elementRef = useRef<HTMLPreElement>(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    return byJSONviewer(element, data, {
      forceMonospace: false,
      themeToggle: true,
      fontSizeControls: true,
      copyButton: true,
      controlsSize: 'small',
      controlsCompact: true,
      controlsPosition: 'top',
      withLinks: true,
      collapsed: true,
      rootCollapsible: false,
      withQuotes: true,
      chunkSize: 1000,
      chunkLatency: 25,
      bigNumbers: false
    });
  }, [data]);

  return <pre ref={elementRef} />;
};
